import { render, staticRenderFns } from "./ElepantSecretPrescriptionDetail.vue?vue&type=template&id=0b14e163"
import script from "./ElepantSecretPrescriptionDetail.vue?vue&type=script&lang=js"
export * from "./ElepantSecretPrescriptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports